module.exports = __webpack_public_path__ + "img/itembg1.21cd5a0d.jpg";